import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import LiveBirths from './LiveBirths/LiveBirths';
import Results from './Results/Results';
import Mortality from './Motality/Mortality';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardVitalStatistics() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to="results" replace />}
                    />

                    <Route
                        path="/results/*"
                        element={
                            <Results
                                dashboardPath={'dashboardvitalstatistics'}
                                menuPath={'results'}
                            />
                        }
                    />
                    <Route path="/mortality/*" element={<Mortality />} />
                    <Route path="/live-births/*" element={<LiveBirths />} />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardVitalStatistics;
